import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgServerlessFunction = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-serverless-function';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M11.595 3.282c-.46.05-.773.142-1.215.357-1.05.509-1.72 1.335-2.03 2.501-.081.306-.086.425-.1 2.71l-.015 2.39H6v1.52h2.24l-.001 2.27c0 2.505-.005 2.563-.25 3.026a2.7 2.7 0 0 1-.409.524c-.456.456-.944.66-1.58.66s-1.124-.204-1.58-.66a2.7 2.7 0 0 1-.409-.524c-.139-.262-.249-.663-.25-.906L3.76 17H2.231l.027.27c.096.948.459 1.731 1.1 2.372.73.73 1.606 1.092 2.642 1.092s1.912-.362 2.642-1.092c.506-.506.813-1.049 1.008-1.782.081-.306.086-.425.1-2.71l.015-2.39H12v-1.52H9.76l.001-2.27c0-2.505.005-2.563.25-3.026.166-.314.619-.767.933-.933.309-.164.674-.25 1.056-.25s.747.086 1.056.25c.314.166.767.619.933.933.139.262.249.663.25.906l.001.15h1.529l-.027-.27c-.153-1.516-1.043-2.696-2.449-3.245-.441-.173-1.171-.26-1.698-.203M13.98 14l-.519.52 1.239 1.24L15.94 17l-1.23 1.23-1.23 1.23.53.53.53.53 1.23-1.23L17 18.06l1.23 1.23 1.23 1.23.53-.53.53-.53-1.23-1.23L18.06 17l1.24-1.24 1.24-1.24-.53-.53-.53-.53-1.24 1.24L17 15.94l-1.23-1.23a54 54 0 0 0-1.251-1.23c-.011 0-.254.234-.539.52"
    })
  }));
});
export default SvgServerlessFunction;